module.exports = __webpack_public_path__ + "img/20200609_140513.fd3de3ed.jpg";